var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('countTo',{staticClass:"value",attrs:{"startVal":0,"endVal":_vm.value,"duration":1000}}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }